<footer class="block bg-gradient-to-b from-gray-100 to-white">
  <hr class="border-b-1 border-gray-200" />
  <div class="flex flex-wrap justify-between">
    <div class="flex flex-grow items-center justify-center">
      <a href="https://www.wings-ict-solutions.eu/">
        <img src="../../../assets/logo-wings.png" class="px-4 object-scale-down w-28">
      </a>
      <div class="text-sm text-gray-600 font-normal text-center">
        Copyright © {{ date }} Wings ICT Solutions
      </div>
    </div>
    <div class="place-self-center mt-1">
      <a href="https://www.facebook.com/WINGS.ICT/" class="text-gray-600 hover:text-blue-600" aria-label="Facebook">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="social-icon" aria-hidden="true">
            <path d="M9 8h2V6.5a1.5 1.5 0 011.5-1.5h1.5V2h-2.5A3.5 3.5 0 008 5.5V8H6v3h2v9h3v-9h2.5l.5-3H9V8z"></path>
          </svg>
        </span>
      </a>
      <a href="https://twitter.com/i/flow/login?redirect_after_login=%2Fwings_ict" class="text-gray-600 hover:text-blue-400 mr-1" aria-label="X (Twitter)">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="social-icon" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
          </svg>
        </span>
      </a>
      <a href="https://www.linkedin.com/company/wings-ict-solutions" class="text-gray-600 hover:text-blue-500 mr-1" aria-label="LinkedIn">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="social-icon" aria-hidden="true">
            <path d="M4 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm0 4h4v14H4V7zm7 0h4v2.3c.6-.8 1.5-1.3 2.5-1.3 2.2 0 4 2 4 4.5V21h-4v-7.5c0-.8-.5-1.5-1.3-1.5-.8 0-1.7.7-1.7 1.5V21h-4V7z"></path>
          </svg>
        </span>
      </a>
      <a href="https://www.youtube.com/channel/UCPotWFhjcmvgQAbBYMYhofQ" class="text-gray-600 hover:text-red-600 mr-1" aria-label="YouTube">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="social-icon" aria-hidden="true">
            <path d="M21.8 8.001s-.2-1.5-.8-2.2c-.7-.8-1.4-.8-1.8-.9-2.5-.2-6.2-.2-6.2-.2s-3.7 0-6.2.2c-.4.1-1.1.1-1.8.9-.6.7-.8 2.2-.8 2.2s-.2 1.8-.2 3.5v1.5c0 1.8.2 3.5.2 3.5s.2 1.5.8 2.2c.7.8 1.6.8 2 .9 1.5.1 6 .2 6 .2s3.7 0 6.2-.2c.4-.1 1.1-.1 1.8-.9.6-.7.8-2.2.8-2.2s.2-1.8.2-3.5v-1.5c0-1.8-.2-3.5-.2-3.5zM9.75 14.02V9.98L14.25 12l-4.5 2.02z"></path>
          </svg>
        </span>
      </a>
    </div>
    
  </div>
</footer>